/* unplugin-vue-components disabled */import script from "./Tabbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tabbar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__